module.exports = __webpack_public_path__ + "static/media/map-bg.fc2bad72.png";